import InputFileTable           from './InputFileTable.js';
import { UseInputFile }         from '../../contexts/InputFilePageContext'

import LoadingTable             from './LoadingTable.js';
import { useUser }              from '../../contexts/UserContext.js';
import api                      from '../../services/api';
import { useEffect, useState }  from 'react';

function InputFileTableContainer () {

    const [loading, isLoading] = useState(true)
    const [__tableContent, __setTableContent] = useState([]);
    
    const { userData, token } = useUser()
    
    const { 

        selectedDate,
        selectedHorizonTypeId,
        updateDemandTable,
 
        handleDemandsModalOpen, 
        setSelectedDemandPostId

    } = UseInputFile();

    const handleFetchTableData = async () => {
        
        try {
            
            if (!selectedDate || !selectedHorizonTypeId) {  
                
                isLoading(false) 
                return;
            }

            const response = await api.get('/getDemandPostsByDateAndHorizonTypeId', {
                params: {
                    selectedDate,              
                    selectedHorizonTypeId,
                    userId: userData.id
                },
                timeout: 3000
            });

            __setTableContent(response.data);

            isLoading(false)

        } catch (error) {
            
            isLoading(false)
            console.log("Error fetching InputFileTableData:", error);

        }
    };

    const handleRowCLick = (id) => {
    
        setSelectedDemandPostId(id) 
        handleDemandsModalOpen()   
    }

    useEffect(() => {
        
        handleFetchTableData();

    }, [updateDemandTable, selectedDate, selectedHorizonTypeId])

    return (
        <>
            {
                loading ? ( 
                    
                    <LoadingTable/>

                ) : (
                <>
   
                    <InputFileTable 
                        tableData={__tableContent} 
                        handleRowCLick={handleRowCLick} 
                    /> 
                       
                </>  
                
            )}
        </>
    ) 
}

export default InputFileTableContainer